import { PagedListRequestInterface, PagedResponseInterface, PaginatedAPIInterface } from '@vendasta/galaxy/table';
import {
  AssistantType,
  GoalApiService,
  GoalInterface,
  ListGoalsRequestSortOptionsInterface,
  Namespace,
} from '@vendasta/ai-assistants';
import { combineLatest, switchMap, Observable, of, map } from 'rxjs';
import { getNamespace } from '../../../core/services/ai-assistant-utils';
import { createConstraintFilters } from '../../../core/services/constraint-utils';

export class AiCapabilityTableDataSource
  implements PaginatedAPIInterface<GoalInterface, void, ListGoalsRequestSortOptionsInterface>
{
  constructor(
    private readonly goalApiService: GoalApiService,
    private readonly assistantType: AssistantType,
    private readonly accountGroupId$: Observable<string>,
    private readonly partnerId$: Observable<string>,
  ) {}

  get(
    req: PagedListRequestInterface<void, ListGoalsRequestSortOptionsInterface>,
  ): Observable<PagedResponseInterface<GoalInterface>> {
    const { cursor, pageSize } = req.pagingOptions ?? {};
    const { text } = req.searchOptions ?? {};
    const sortOptions = req.sorting ?? [];
    return combineLatest([this.accountGroupId$, this.partnerId$]).pipe(
      switchMap(([accountGroupId, partnerId]) => {
        const namespace = getNamespace(accountGroupId, partnerId);

        if (!namespace)
          return of({
            data: [],
            pagingMetadata: {
              nextCursor: '',
              hasMore: false,
            },
          });

        const namespaces: Namespace[] = [namespace, new Namespace({ globalNamespace: {} })];

        const constraintFilters = createConstraintFilters(partnerId, accountGroupId, this.assistantType);

        return this.goalApiService
          .list({
            filters: {
              namespaces: namespaces,
              searchTerm: text,
              sortOptions: sortOptions,
              omitOverrides: true,
              ...(constraintFilters.length > 0 && { constraintFilters }),
            },
            pagingOptions: {
              cursor,
              pageSize,
            },
          })
          .pipe(
            map((res) => ({
              data: res.goals ?? [],
              pagingMetadata: {
                nextCursor: res.metadata?.nextCursor ?? '',
                hasMore: res.metadata?.hasMore ?? false,
              },
            })),
          );
      }),
    );
  }
}
